var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuoteTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 42,
    viewBox: "0 0 49 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0016 0.824322L19.5443 4.04505C15.815 6.53122 13.0463 9.1304 11.2382 11.8426C9.54305 14.4418 8.6955 16.8714 8.6955 19.1316C8.6955 21.2787 9.99509 22.6913 12.5943 23.3694C14.8544 23.8214 16.7756 24.8385 18.3577 26.4206C19.9398 27.8897 20.7308 29.9239 20.7308 32.523C20.7308 35.1222 19.8268 37.2694 18.0186 38.9645C16.2105 40.6596 14.1764 41.5072 11.9162 41.5072C9.09102 41.5072 6.54835 40.4336 4.28819 38.2864C2.02803 36.1393 0.897952 32.523 0.897952 27.4377C0.897952 22.8044 2.19754 18.1145 4.79672 13.3682C7.50891 8.50886 11.5772 4.32757 17.0016 0.824322ZM45.1405 0.824322L47.6832 4.04505C43.954 6.53122 41.1853 9.1304 39.3771 11.8426C37.682 14.4418 36.8345 16.8714 36.8345 19.1316C36.8345 21.2787 38.134 22.6913 40.7332 23.3694C42.9934 23.8214 44.9145 24.8385 46.4966 26.4206C48.0787 27.8897 48.8698 29.9239 48.8698 32.523C48.8698 35.1222 47.9657 37.2694 46.1576 38.9645C44.3495 40.6596 42.3153 41.5072 40.0552 41.5072C37.23 41.5072 34.6873 40.4336 32.4271 38.2864C30.167 36.1393 29.0369 32.523 29.0369 27.4377C29.0369 22.8044 30.3365 18.1145 32.9357 13.3682C35.6479 8.50886 39.7162 4.32757 45.1405 0.824322Z",
    fill: "#142943"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteTop);
export default __webpack_public_path__ + "static/media/QuoteTop.de14f7732a846cef07ffbe0a70a3abef.svg";
export { ForwardRef as ReactComponent };